"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashWidgetId = void 0;
var crypto_1 = __importDefault(require("crypto"));
var hashWidgetId = function (_a) {
    var interactionName = _a.interactionName, blockId = _a.blockId, interactionContentIdentifier = _a.interactionContentIdentifier;
    var content = "".concat(interactionName).concat(blockId).concat(interactionContentIdentifier);
    return crypto_1.default.createHash("md5").update(content).digest("hex");
};
exports.hashWidgetId = hashWidgetId;
